import React from 'react';
import PropTypes from 'prop-types';
import CancelIcon from '@mui/icons-material/Cancel';
import { Button, useUpdateMany, useNotify, useRefresh, useUnselectAll } from 'react-admin';

export const BulkApplicationNotWorkedOn: React.FC<{
  selectedIds: any;
}> = ({ selectedIds }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll('applications');
  const [updateMany, { isLoading }] = useUpdateMany();
  const handleOnClick = () => {
    updateMany(
    'applications', {
      ids: selectedIds,
      data: {
        workedOn: false,
      },
    },
    {
      mutationMode: "pessimistic",
      onSettled: () => {
        unselectAll();
        notify(`resources.applications.notification.not_worked_on`);
        refresh();
      },
      onError: () => {
        notify("resources.applications.notification.error", {
          type: "warning",
        });
      },
    });
  }

  return (
    <Button label="resources.applications.actions.not_worked_on" onClick={handleOnClick} disabled={isLoading}>
      <CancelIcon />
    </Button>
  );
};

BulkApplicationNotWorkedOn.propTypes = {
  selectedIds: PropTypes.arrayOf(PropTypes.any).isRequired,
};
